<template>
  <div >    
    <!--<div class="pt-24 mb-12">
      <div class="container px-3 mx-auto flex flex-wrap flex-col md:flex-row items-center text-white">
        <div
          class="flex flex-col w-full md:w-2/5 justify-center items-start text-center md:text-left"
        >
          <p class=" tracking-loose w-full">¿Tienen problemas con sus direcciones y necesitas información?</p>
          <h1 class="my-4 text-5xl font-bold leading-tight">
            Api de ubicación e información rápida y sencilla
          </h1>
          <p class="leading-normal text-2xl mb-8">
            Geocodificación y mapas , accesibles, escalables y con actualizaciones diarias
          </p>

        <button  v-on:click="login()"
          class="mx-auto lg:mx-0 hover:underline bg-white text-gray-800 font-bold rounded-full mt-4 lg:mt-0 py-4 px-8 shadow opacity-75"
        >
        Empezar
        </button>
        </div>
		  
        <div class="w-full md:w-3/5 py-6 text-center">
          <img class="w-full md:w-4/5 z-50" src="../../src/assets/img/map.svg" />
        </div>
      </div>
    </div>

		<div class="pt-24 mb-12">
			<div style="position: relative; height: 1000px;  margin: auto !important; top: -22px;">
				<div style="left: 500px; position: absolute;">
					<div class="flex flex-col w-full md:w-2/5 justify-center items-start text-center md:text-left" style="width: 1200px; height: 450px; position: relative;">
						<h1 class="my-4 text-5xl font-bold leading-tight" style="font-size: 65px;">
							TIENES PÁGINA ECOMMERCE
						</h1>
						<p class="leading-normal text-2xl mb-8" style="font-size: 45px; margin: 10px 70px;">
							¿Y no logras ubicar bien a tus clientes?
						</p>
					</div>

					<div style="top: 720px; left: 200px; position: absolute;">
						<p class=" tracking-loose w-full" style="margin-top: 0px; font-size: 35px; color: #ffffff;">Ingresa aquí y utiliza este modelo</p>

						<div style="margin: 30px 170px;">
							<a href="/resources/ecommerce" style="">
								<button class="mx-auto lg:mx-0 hover:underline rounded-full mt-4 lg:mt-0 py-4 px-8" style="background-color: #409eff; color: #ffffff; font-size: 25px;">
									Ecommerce
								</button>
							</a>
						</div>
					</div>
				</div>

				<div style="">
					<img style="margin: 0; width: 100vw; height: 93vh;" src="../../src/assets/img/home/ecommerce-portada.png">
				</div>					
			</div>
		</div>-->

		<div class="pt-24 mb-12">
			<div class="container px-3 mx-auto flex flex-wrap flex-col md:flex-row items-center text-white" style="width: 1200px;">
				<div class="flex flex-col w-full md:w-2/5 justify-center items-start text-center md:text-left" style="margin-left: 0px;">
					<h1 class="my-4 text-5xl font-bold leading-tight">
						Tienes una página ecommerce
					</h1>
					<p class="leading-normal text-2xl mb-8">
						¿Y no logras ubicar bien a tus clientes?
					</p>

					<a href="/resources/ecommerce">
					<button class="mx-auto lg:mx-0 hover:underline bg-white text-gray-800 font-bold
							rounded-full mt-4 lg:mt-0 py-4 px-8 shadow opacity-75" style="font-size: 21px;">
						Ingresa una dirección
					</button>
					</a>
				</div>
			
				<div class="w-full md:w-3/5 py-6 text-center">
					<img class="w-full md:w-5/5 z-50" style="margin-left: 50px;" src="../../src/assets/img/home/ecommerce-portada.png" />
				</div>
			</div>
		</div>

    <div class="relative mt-12 lg:-mt-24">
      <svg
        viewBox="0 0 1428 174"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g
            transform="translate(-2.000000, 44.000000)"
            fill="#FFFFFF"
            fill-rule="nonzero"
          >
            <path
              d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
              opacity="0.100000001"
            ></path>
            <path
              d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
              opacity="0.100000001"
            ></path>
            <path
              d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
              id="Path-4"
              opacity="0.200000003"
            ></path>
          </g>
          <g
            transform="translate(-4.000000, 76.000000)"
            fill="#FFFFFF"
            fill-rule="nonzero"
          >
            <path
              d="M0.457,34.035 C57.086,53.198 98.208,65.809 123.822,71.865 C181.454,85.495 234.295,90.29 272.033,93.459 C311.355,96.759 396.635,95.801 461.025,91.663 C486.76,90.01 518.727,86.372 556.926,80.752 C595.747,74.596 622.372,70.008 636.799,66.991 C663.913,61.324 712.501,49.503 727.605,46.128 C780.47,34.317 818.839,22.532 856.324,15.904 C922.689,4.169 955.676,2.522 1011.185,0.432 C1060.705,1.477 1097.39,3.129 1121.236,5.387 C1161.703,9.219 1208.621,17.821 1235.4,22.304 C1285.855,30.748 1354.351,47.432 1440.886,72.354 L1441.191,104.352 L1.121,104.031 L0.457,34.035 Z"
            ></path>
          </g>
        </g>
      </svg>
    </div>

<section class="bg-white border-b py-8">
      <div class="container max-w-5xl mx-auto m-8">
        <h1
          class="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800"
        >
          Servicios
        </h1>
        <div class="w-full mb-4">
          <div
            class="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"
          ></div>
        </div>

        <div class="flex flex-wrap">
          <div class="w-5/6 sm:w-1/2 p-6">
            <h3 class="text-3xl text-gray-800 font-bold leading-none mb-3">
              Geocoding
            </h3>
            <p class="text-gray-600 mb-8">
              Convierte tus datos de direcciones en ubicaciones en un mapa y viceversa con nuestra API de geocodificacion.<br /><br />

              Ir a:
              <a class="text-orange-500 underline" href="https://docs.geodir.co/geocoding/"
                >Documentacion</a
              >
            </p>
          </div>
          <div class="w-full sm:w-1/2 p-6">
            <img class="w-full md:w-4/5 z-50" src="../../src/assets/img/map.svg" />
            
          </div>
        </div>

        <div class="flex flex-wrap flex-col-reverse sm:flex-row">
          <div class="w-full sm:w-1/2 p-6 mt-6">
            <img class="w-5/6 sm:h-64 mx-auto" viewBox="0 0 1176.60617 873.97852" src="../../src/assets/img/city.svg" />
           
          </div>
          <div class="w-full sm:w-1/2 p-6 mt-6">
            <div class="align-middle">
              <h3 class="text-3xl text-gray-800 font-bold leading-none mb-3">
                Places
              </h3>
              <p class="text-gray-600 mb-8">
                Incorpora Place Details, Place Search y Place Autocomplete en tus apps.<br /><br />

                Ir a:
                <a class="text-orange-500 underline" href="https://docs.geodir.co/places/"
                  >Places</a
                >
              </p>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap">
          <div class="w-5/6 sm:w-1/2 p-6">
            <h3 class="text-3xl text-gray-800 font-bold leading-none mb-3">
              Maps
            </h3>
            <p class="text-gray-600 mb-8">
              Permite que tus usuarios accedan al mundo real a través de mapas estáticos y dinámicos para la Web y los dispositivos móviles.<br /><br />

              Ir a:
              <a class="text-orange-500 underline" href="https://maps.geodir.co/"
                >Maps</a
              >
            </p>
          </div>
          <div class="w-full sm:w-1/2 p-6">
            <img class="w-full md:w-4/5 z-50" src="../../src/assets/img/world_map_.svg" />
            
          </div>
        </div>

      <div class="flex flex-wrap flex-col-reverse sm:flex-row">
          <div class="w-full sm:w-1/2 p-6 mt-6">
            <img class="w-5/6 sm:h-64 mx-auto" viewBox="0 0 1176.60617 873.97852" src="../../src/assets/img/car.svg" />
           
          </div>
          <div class="w-full sm:w-1/2 p-6 mt-6">
            <div class="align-middle">
              <h3 class="text-3xl text-gray-800 font-bold leading-none mb-3">
                Routing
              </h3>
              <p class="text-gray-600 mb-8">
                Brinda instrucciones sobre cómo llegar de varios medios de transporte.<br /><br />

                Ir a:
                <a class="text-orange-500 underline" href="https://maps.geodir.co/"
                  >Routing</a
                >
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>


    <section class="bg-white border-b py-8">
      <div class="container mx-auto flex flex-wrap pt-4 pb-12">
        <h1
          class="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800"
        >
          Satisface tus necesidades
        </h1>
        <div class="w-full mb-4">
          <div
            class="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"
          ></div>
        </div>

        <div class="w-full md:w-1/3 p-6 flex flex-col flex-grow flex-shrink">
          <div
            class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow"
          >
            <div class="flex items-center justify-center">
               <img class="w-10 h-10" src="../../src/assets/img/icons/image-plus.svg" />             
            </div>
   
            <div class="w-full font-bold text-xl text-gray-800 px-6">
              Actualización
            </div>
            <p class="text-gray-800 text-base px-6 mb-5">
              Constante actualización de nuestra cartografía orientado siempre a las necesidades de los usuarios.
            </p>
            
          </div>
          <div class="flex items-center justify-center">
              <img class="w-50 h-50" src="../../src/assets/img/clients/open_map.svg" />
            </div>
          
        </div>

        <div class="w-full md:w-1/3 p-6 flex flex-col flex-grow flex-shrink">
          <div
            class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow"
          >
            <div class="flex items-center justify-center">
               <img class="w-10 h-10" src="../../src/assets/img/icons/usd-circle.svg" />             
            </div>
   
            <div class="w-full font-bold text-xl text-gray-800 px-6">
              Accesible
            </div>
            <p class="text-gray-800 text-base px-6 mb-5">
              Precios a medida para su negocio, con tarifas personalizadas sin acuerdos complicados y con demos para su evaluación.
            </p>
            
          </div>
          <div class="flex items-center justify-center">
              <img class="w-50 h-50" src="../../src/assets/img/clients/finance_analysis_.svg" />
            </div>
          
        </div>

        <div class="w-full md:w-1/3 p-6 flex flex-col flex-grow flex-shrink">
          <div
            class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow"
          >
            <div class="flex items-center justify-center">
               <img class="w-10 h-10" src="../../src/assets/img/icons/user-arrows.svg" />             
            </div>
   
            <div class="w-full font-bold text-xl text-gray-800 px-6">
              Comunicación
            </div>
            <p class="text-gray-800 text-base px-6 mb-5">
              Constante comunicación con el usuario sobre sus complicaciones, necesidades, consultas, personalizaciones para el mejor aprovechamiento de la herramienta.
            </p>
            
          </div>
          <div class="flex items-center justify-center">
              <img class="w-50 h-50" src="../../src/assets/img/clients/online_team_meeting_.svg" />
            </div>
          
        </div>


      </div>
    </section>



<section class="bg-gray-100 py-8">
      <div class="container mx-auto px-2 pt-4 pb-12 text-gray-800">
        <h1
          class="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800"
        >
          Clientes
        </h1>
        
        <div class="grid grid-cols-4 gap-4">
          <div>
            <img class="h-20 mt-8 text-center rounded" src="../../src/assets/img/clientes/geodir-entel-logo.png" />
          </div>
          <div>
            <img class="h-20 mt-8 text-center rounded" src="../../src/assets/img/clientes/geodir-interbank-logo.png" />
          </div>
          <div>
            <img class="mt-10 text-center rounded" src="../../src/assets/img/clientes/geodir-mtc-logo.png" />
          </div>
          <div>
            <img class="h-20 mt-8 text-center rounded" src="../../src/assets/img/clientes/geodir-alicorp-logo.png" />
          </div>
          <div>
            <img class="h-20 mt-8 text-center rounded" src="../../src/assets/img/clientes/geodir-sat-logo.png" />
          </div>
          <div>
            <img class="h-20 mt-8 text-center rounded" src="../../src/assets/img/clientes/geodir-sodexo-logo.png" />
          </div>
          <div>
            <img class="h-20 mt-8 text-center rounded" src="../../src/assets/img/clientes/geodir-unique-logo.png" />
          </div>
          <div>
            <img class="h-20 mt-8 text-center rounded" src="../../src/assets/img/clientes/geodir-el-comercio-logo.png" />
          </div>
        </div>
      </div>

      <div class="block">
        <el-carousel height="300px" style="margin: 60px 250px">
          <el-carousel-item v-for="testimonial in testimonials" :key="testimonial" class="text-center" style="display: flex; background-color: transparent">
				<el-card style="width: 380px; margin: 40px">
					<div style="height: 80px">{{ testimonial[0].content }}</div>
					<div class="mt-4 pl-4 pr-4" style="display: flex">
						<img alt="" width="80" height="80" :src="getImage(testimonial[0].image)">
						<div style="width: 226px">
							<h6>{{ testimonial[0].name }}</h6>
							<span style="font-size: 12px">{{ testimonial[0].role }}</span>
						</div>
					</div>
				</el-card>

				<el-card style="width: 380px; margin: 40px">
					<div style="height: 80px">{{ testimonial[1].content }}</div>
					<div class="mt-4 pl-4 pr-4" style="display: flex">
						<img alt="" width="80" height="80" :src="getImage(testimonial[1].image)">
						<div style="width: 226px">
							<h6>{{ testimonial[1].name }}</h6>
							<span style="font-size: 12px">{{ testimonial[1].role }}</span>
						</div>
					</div>
				</el-card>

				<el-card style="width: 380px; margin: 40px">
					<div style="height: 80px">{{ testimonial[2].content }}</div>
					<div class="mt-4 pl-4 pr-4" style="display: flex">
						<img alt="" width="80" height="80" :src="getImage(testimonial[2].image)">
						<div style="width: 226px">
							<h6>{{ testimonial[2].name }}</h6>
							<span style="font-size: 12px">{{ testimonial[2].role }}</span>
						</div>
					</div>
				</el-card>
          </el-carousel-item>
        </el-carousel>
      </div>
    </section>

    <!-- Change the colour #f8fafc to match the previous section colour -->
    <svg
      class="wave-top"
      viewBox="0 0 1439 147"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-1.000000, -14.000000)" fill-rule="nonzero">
          <g class="wave" fill="#f8fafc">
            <path
              d="M1440,84 C1383.555,64.3 1342.555,51.3 1317,45 C1259.5,30.824 1206.707,25.526 1169,22 C1129.711,18.326 1044.426,18.475 980,22 C954.25,23.409 922.25,26.742 884,32 C845.122,37.787 818.455,42.121 804,45 C776.833,50.41 728.136,61.77 713,65 C660.023,76.309 621.544,87.729 584,94 C517.525,105.104 484.525,106.438 429,108 C379.49,106.484 342.823,104.484 319,102 C278.571,97.783 231.737,88.736 205,84 C154.629,75.076 86.296,57.743 0,32 L0,0 L1440,0 L1440,84 Z"
            ></path>
          </g>
          <g transform="translate(1.000000, 15.000000)" fill="#FFFFFF">
            <g
              transform="translate(719.500000, 68.500000) rotate(-180.000000) translate(-719.500000, -68.500000) "
            >
              <path
                d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
                opacity="0.100000001"
              ></path>
              <path
                d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
                opacity="0.100000001"
              ></path>
              <path
                d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
                opacity="0.200000003"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>

    <section class="container mx-auto text-center py-6 mb-12">
      <h1
        class="w-full my-2 text-5xl font-bold leading-tight text-center text-white"
      >
        Comunicate con nosotros
      </h1>
      <div class="w-full mb-4">
        <div
          class="h-1 mx-auto bg-white w-1/6 opacity-25 my-0 py-0 rounded-t"
        ></div>
      </div>
      
    </section>


<!--Footer-->
    <footer class="bg-purple-100">
       <div class="flex flex-wrap justify-center p-6">
      <div class="flex flex-wrap mb-4 w-full">
        <div class="w-full sm:w-1/2 md:w-1/2 lg:w-1/4 ">
          <h3 class="text-3xl py-4">Acerca de nosotros</h3>
          <p>Somos una empresa comprometida con la satisfacción del usuario que trata de estar a la vanguardia de la tecnología y brindar un servicio de calidad a nuestros usuarios.
          </p>
        </div>
        <div class="w-full sm:w-1/2 md:w-1/2 lg:w-1/4 pl-8">
          <h3 class="text-3xl py-4">Productos</h3>
          <ul>
            <li><a href="https://maps.geodir.co">Maps</a></li>
            <li><a href="https://docs.geodir.co/geocoding">Geocoding</a></li>
          </ul>
        </div>
        <div class="w-full sm:w-1/2 md:w-1/2 lg:w-1/4 pl-8">
          <!-- <h3 class="text-3xl py-4">Contacto</h3>
          <ul>
            <li><i class="uil uil-building"></i> Cal Pedro Ruiz Gallo 668, Breña - Lima</li>
            <li><i class="uil uil-envelope"></i> contacto@geodir.co</li>
            <li><i class="uil uil-mobile-android-alt"></i> (01) 3055049</li>
          </ul> -->
        </div>
        <div class="w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
          <div class="flex items-center justify-center">
              <img class="h-15 mt-10" src="../../src/assets/img/logo/geodir-logo.svg" />
            </div>
        </div>
      </div>
    </div>
    <div class="bg-purple-500 p-2 pl-6">
      <p class="bottom">© Copyright 2021 - Geodir</p>
    </div>      
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src

const $ = require('jquery');

export default {
	name: "Home",
	components: {
	},
	data() {
		return {
			testimonials: [[
				{name: "Carlos Zuzunaga", role: "Director de Planificación y Estrategia de Alicorp SA", content: "Geodir nos proporciona información importante para realizar nuestros estudios de análisis de datos de punto de venta", image: "geodir-alicorp-testimonial.png"},
				{name: "William Ventura", role: "Gerente de Calidad de Datos SAT", content: "Para nuestra cartera de clientes Geodir Builder nos ayudó mucho en la gestión y sectorización de nuestro personal", image: "geodir-sat-testimonial.png"},
				{name: "Andres Cannesa", role: "Gerente de Marketing de Sodexo", content: "Builder, es un servicio eficaz para reducir costos y optimizar tiempos en visitas de campo", image: "geodir-sodexo-testimonial.png"}
			], [
				{name: "Christian Burgos", role: "Analista de Datos Serlefin Perú", content: "Agradecido por el apoyo brindado en el uso de la herramienta Geodir Builder para nuestras operaciones", image: "geodir-serlefin-testimonial.png"},
				{name: "Percy Fonseca", role: "Analista de Proyectos Natura", content: "Geodir Maps, es un trome en la geolocalización de nuestros clientes, una plataforma amigable de fácil uso y rápida ubicación", image: "geodir-natura-testimonial.png"},
				{name: "Tania Gómez", role: "Gerencia de Ventas Darnel Perú", content: "Son una empresa seria con un producto competente y de calidad", image: "geodir-darnel-testimonial.png"}
			]]
		};
  },
	methods:{
		login() {
			console.log('login');
			console.log(this.$route.fullPath);

			
			let params = {};
			params.redirect_uri = process.env.VUE_APP_URL_REDIRECT_URL + '/geodir';

			params.client_id = process.env.VUE_APP_URL_OAUTH_ID;
			params.response_type = "code";
			params.scope = "maps geocoding builder";
			params.state = '152fgfd5';
			var recursiveDecoded = decodeURIComponent($.param(params));
			console.log();
			//localStorage.setItem("LOGINREDIRECT", JSON.stringify(redirectLogin));
			//redirect for oauth
			window.location =
			process.env.VUE_APP_SEGURIDAD + "/oauth/authorize" +
			"?" +
			recursiveDecoded;
		},
		getImage(image) {
			return require('../../src/assets/img/testimonial/' + image);
		}
	}  
};
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #d6bcfa;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #bee3f8;;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #e9d8fd;
  }
</style>
